import { ResourceType } from '../resources/ResourceType';
const spriteVert = `
attribute vec3 aVertexPosition;
attribute vec2 aTextureCoord;
uniform mat4 uModelMatrix;
uniform mat4 uViewMatrix;
uniform mat4 uProjectionMatrix;

varying highp vec2 vTextureCoord;

void main() {
    gl_Position = uProjectionMatrix * uViewMatrix * uModelMatrix * vec4(aVertexPosition, 1.0);
    vTextureCoord = aTextureCoord;
}
`;
const spriteFrag = `
precision highp float;
varying highp vec2 vTextureCoord;
varying mediump vec4 lastCoord;
uniform sampler2D uSampler;
uniform float gamma;
uniform float brightness;
uniform float contrast;
uniform int border;
uniform int useLinear;
uniform vec2 textureScale;

vec4 texture2DLinear(sampler2D texSampler, highp vec2 uv) {
  vec2 pixelOff = vec2(0.5,0.5)/textureScale;

  vec2 imagePosCenterity = fract(uv * textureScale);
  if (abs(imagePosCenterity.x-0.5) < 0.001 || abs(imagePosCenterity.y-0.5) < 0.001) {
      pixelOff = pixelOff-vec2(0.00001,0.00001);
  }

  vec4 tl = texture2D(texSampler, uv + vec2(-pixelOff.x,-pixelOff.y));
  vec4 tr = texture2D(texSampler, uv + vec2(pixelOff.x,-pixelOff.y));
  vec4 bl = texture2D(texSampler, uv + vec2(-pixelOff.x,pixelOff.y));
  vec4 br = texture2D(texSampler, uv + vec2(pixelOff.x,pixelOff.y));
  vec2 f = fract( (uv.xy-pixelOff) * textureScale );
  vec4 tA = mix( tl, tr, f.x );
  vec4 tB = mix( bl, br, f.x );
  return mix( tA, tB, f.y );
}

void main() {
  vec2 textureCoords = vTextureCoord;
  vec4 diffuseColor;
  
  if(useLinear == 1) {
    diffuseColor = texture2DLinear(uSampler, textureCoords);
  } else {
    diffuseColor = texture2D(uSampler, textureCoords);
  }

  vec3 bright = vec3(diffuseColor.rgb) + vec3(brightness, brightness, brightness);
  vec3 colorContrast = bright * contrast;
  vec3 colorGamma = colorContrast;
  colorGamma = pow(colorGamma, vec3(1.0/gamma));

  vec2 borderSizeLeftTop = vec2(5.0,5.0)/textureScale;
  vec2 borderSizeRightBottom = textureScale - borderSizeLeftTop;

  if (border == 1) {
    if (textureCoords.x < borderSizeLeftTop.x) {
      colorGamma = vec3(0, 0, 0);
      diffuseColor.a = 1.0;
    }

    if (textureCoords.x > borderSizeRightBottom.x) {
      colorGamma = vec3(0, 0, 0);
      diffuseColor.a = 1.0;
    }

    if (textureCoords.y < borderSizeLeftTop.y) {
      colorGamma = vec3(0, 0, 0);
      diffuseColor.a = 1.0;
    }

    if (textureCoords.y > borderSizeRightBottom.y) {
      colorGamma = vec3(0, 0, 0);
      diffuseColor.a = 1.0;
    }
  }
  

  gl_FragColor.rgb = colorGamma;
  gl_FragColor.a = diffuseColor.a;
}
`;
export class Shader {
    constructor(renderer, vertex_program = spriteVert, fragment_program = spriteFrag) {
        this.renderer = renderer;
        const gl = renderer.getGL();
        const vertexShader = Shader.loadShader(gl, gl.VERTEX_SHADER, vertex_program);
        const fragmentShader = Shader.loadShader(gl, gl.FRAGMENT_SHADER, fragment_program);
        this.shaderProgram = this.renderer.resources.createResource(ResourceType.Program, 'sprite').resource;
        if (this.shaderProgram !== null) {
            gl.attachShader(this.shaderProgram, vertexShader);
            gl.attachShader(this.shaderProgram, fragmentShader);
            gl.linkProgram(this.shaderProgram);
            if (!gl.getProgramParameter(this.shaderProgram, gl.LINK_STATUS)) {
                console.error('Shader program link failure: ' +
                    gl.getProgramInfoLog(this.shaderProgram));
            }
        }
    }
    static loadShader(gl, type, source) {
        const shader = gl.createShader(type);
        if (shader !== null) {
            gl.shaderSource(shader, source);
            gl.compileShader(shader);
            if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
                console.error('Failed to compile shader: ' + gl.getShaderInfoLog(shader));
                gl.deleteShader(shader);
                return null;
            }
        }
        else {
            return null;
        }
        return shader;
    }
    getAttrib(name) {
        const gl = this.renderer.getGL();
        return gl === null || gl === void 0 ? void 0 : gl.getAttribLocation(this.shaderProgram, name);
    }
    getUniform(name) {
        const gl = this.renderer.getGL();
        return gl === null || gl === void 0 ? void 0 : gl.getUniformLocation(this.shaderProgram, name);
    }
    use() {
        const gl = this.renderer.getGL();
        gl === null || gl === void 0 ? void 0 : gl.useProgram(this.shaderProgram);
    }
}
//# sourceMappingURL=Shader.js.map